import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-phone-link',
    templateUrl: './detail-phone-link.component.html',
    styleUrls: ['./detail-phone-link.component.scss'],
    standalone: true,
})
export class DetailPhoneLinkComponent {
    public title = input<string>();
    public linkLabel = input<string>();
    public phone = input.required<string>();
    public ariaLabel = input<string>();
    public outlined = input<boolean>(false);

}
